export default "__VITE_ASSET__CgptxuEN__"